import script from "./DarmaAyudwi.vue?vue&type=script&setup=true&lang=js"
export * from "./DarmaAyudwi.vue?vue&type=script&setup=true&lang=js"

import "./DarmaAyudwi.vue?vue&type=style&index=0&id=2e577d13&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e577d13"]])

export default __exports__